import { IMPORT_DRIVERS_CSV } from "../services/ApiCalls";
import URLS from "../services/URLS";
import noImg from "../Assets/images/no-img.png";

export const noImgPLaceHolder = noImg;

export const paginationLimitOptionArr = [2, 5, 10, 20, 100, 200, 500, 1000];
export const statusFilterOptionArr = [
  { value: "", label: "All" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];
export const openCloseFilterOptionArr = [
  { value: "", label: "All" },
  { value: "open", label: "Open" },
  { value: "close", label: "Close" },
];
export const GroupByFilterOptionArr = [
  { value: "week", label: "Week" },
  { value: "year", label: "year" },
  { value: "month", label: "Month" },
];

export const csvImportEnum = {
  drivers: {
    title: "Drivers",
    sampleUrl: URLS.API_URL + "public/importDriver.csv",
    api: (data) => IMPORT_DRIVERS_CSV(data),
  },
};

export const moneyTransFerType = {
  walletToBank: "walletToBank",
  BankToWallet: "BankToWallet",
};

export const weekLabels = [
  "sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const monthsLabels = [
  "Jan",
  "Feb",
  "March",
  "April",
  "May",
  "June",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const datesLabels = Array.from({ length: 31 }, (_, index) => index + 1);
